import { create } from 'zustand'

interface ModalState {
   isNewLeadsCampaignModalOpen: boolean
   openNewLeadsCampaignModal: () => void
   closeNewLeadsCampaignModal: () => void
}

export const useNewLeadsCampaignModalStore = create<ModalState>((set) => ({
   isNewLeadsCampaignModalOpen: false,
   openNewLeadsCampaignModal: () => set({ isNewLeadsCampaignModalOpen: true }),
   closeNewLeadsCampaignModal: () =>
      set({ isNewLeadsCampaignModalOpen: false }),
}))
